/* eslint-disable import/no-unresolved */
/* eslint-disable import/order */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { FaStar } from 'react-icons/fa';
import { IoMdClose } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'swiper/css';

// import carrying from 'assets/images/carring.webp';
// import postpartumShape from 'assets/images/postpartum-shape.webp';
// import smile from 'assets/images/smile.svg';
// import checkMark from 'assets/images/check-mark.svg';
// import strawberry from 'assets/images/strawberry.svg';
// import bodyShape from 'assets/images/body-shape.svg';
// import plant from 'assets/images/plant.svg';
import heart from 'assets/images/multi-heart.svg';
import linearGradientBg from 'assets/images/linear-gradient-bg.webp';
import angie from 'assets/images/angie.webp';
import caro from 'assets/images/caro.webp';
import tati from 'assets/images/tati.webp';
import { useLocalStorage } from 'utils/hooks/useLocalStorage';
import { getVariant } from 'utils/experiments/useExperiment';
import { KEYS } from '../utils/constants';
import { useGetParams } from '../utils/useGetParams';
import { usePaywallExit } from '../utils/usePaywallExit';
import { handleTrackEvent } from '../utils/handleTrackEvent';

// import PerkScreen from '../PerkScreen';
import SinglePayment from '../SinglePayment';
import Offerings from '../Offerings';
import TrialScreen from '../TrialScreen';
import ExitOfferModal from 'components/evieApp/ExitOfferModal';

const PostpartumPlan = ({
  offerings,
  selectedOffer,
  setSelectedOffer,
  isDiscount,
  identifier,
  isFetchingOfferings,
}) => {
  const { t } = useTranslation();
  const { planStep, entry } = useGetParams();
  const [storedPath] = useLocalStorage(KEYS.PATH);
  const { isExitModalOpen, handleGoBack, handleAcceptFreeTier, handleDismissModal } = usePaywallExit({
    screen: 'plans',
  });

  const entryPoint = entry || 'link';
  const showSkipLink = getVariant('paywall') === 'A' && entryPoint === 'post_signup';

  useEffect(() => {
    if (planStep === 2) {
      handleTrackEvent('Paywall viewed', {
        entry_point: entryPoint,
        path: storedPath,
        plan_step: planStep,
        paywall_variant: getVariant('paywall'),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planStep]);

  return (
    <>
      {/* {planStep === 1 && (
        <PerkScreen>
          <LazyLoadImage
            effect="opacity"
            src={carrying}
            alt="woman carrying baby"
            className="info-screen__bgimg perks"
          />
          <section className="info-screen__footer perks">
            <div className="info-screen__footer_topbg plan" />
            <div className="info-screen__footer_topbg second" />
            <div className="info-screen__footer_icon perks">
              <img src={postpartumShape} alt="silhouette of woman carrying baby" />
            </div>
            <h2 className="info-screen__footer_title">{t('evieOnboarding.perkScreen.title2')}</h2>
            <p className="info-screen__footer_content perks">{t('evieOnboarding.perkScreen.description2')}</p>
            <div className="perk-screen__perkcard">
              <img className="perk-screen__perkcard_icon" src={smile} alt="smily" />
              <p className="perk-screen__perkcard_content">{t('evieOnboarding.perkScreen.perks.physio')}</p>
            </div>
            <div className="perk-screen__perkcard">
              <img className="perk-screen__perkcard_icon" src={checkMark} alt="checkmark" />
              <p className="perk-screen__perkcard_content">{t('evieOnboarding.perkScreen.perks.chat')}</p>
            </div>
            <div className="perk-screen__perkcard">
              <img className="perk-screen__perkcard_icon" src={strawberry} alt="strawberry" />
              <p className="perk-screen__perkcard_content">{t('evieOnboarding.perkScreen.perks.exercises')}</p>
            </div>
            <div className="perk-screen__perkcard">
              <img className="perk-screen__perkcard_icon" src={bodyShape} alt="body shape" />
              <p className="perk-screen__perkcard_content">{t('evieOnboarding.perkScreen.perks.routines')}</p>
            </div>
            <div className="perk-screen__perkcard">
              <img className="perk-screen__perkcard_icon" src={plant} alt="plant" />
              <p className="perk-screen__perkcard_content">{t('evieOnboarding.perkScreen.perks.audio')}</p>
            </div>
          </section>
        </PerkScreen>
      )} */}
      {planStep === 1 && <TrialScreen selectedOffer={selectedOffer} />}
      {planStep === 2 && (
        <SinglePayment>
          <div className="trial-screen__goback">
            <IoMdClose className="trial-screen__goback_icon" onClick={handleGoBack} />
          </div>
          <Swiper
            speed={600}
            slidesPerView={1}
            loop
            modules={[Autoplay]}
            autoplay={
              window.matchMedia('(prefers-reduced-motion: reduce)').matches
                ? false
                : { delay: 7000, disableOnInteraction: true }
            }
          >
            <SwiperSlide>
              <section className="single-payment__testimonials">
                <div className="single-payment__testimonial">
                  <div>
                    <FaStar className="single-payment__testimonial_star" />
                    <FaStar className="single-payment__testimonial_star" />
                    <FaStar className="single-payment__testimonial_star" />
                    <FaStar className="single-payment__testimonial_star" />
                    <FaStar className="single-payment__testimonial_star" />
                  </div>
                  <p className="single-payment__testimonial_content">
                    {t('evieOnboarding.planScreen.testimonials.postpartum.angie.content')}
                  </p>
                  <p className="single-payment__testimonial_author">
                    {t('evieOnboarding.planScreen.testimonials.postpartum.angie.author')}
                  </p>
                </div>
                <img
                  className="single-payment__bgimg testimonialbg"
                  src={linearGradientBg}
                  alt="linear gradient background"
                />
                <img
                  className="single-payment__bgimg single-payment__testimonials_img"
                  src={angie}
                  alt="Woman and baby"
                />
              </section>
            </SwiperSlide>
            <SwiperSlide>
              <section className="single-payment__testimonials">
                <div className="single-payment__testimonial">
                  <div>
                    <FaStar className="single-payment__testimonial_star" />
                    <FaStar className="single-payment__testimonial_star" />
                    <FaStar className="single-payment__testimonial_star" />
                    <FaStar className="single-payment__testimonial_star" />
                    <FaStar className="single-payment__testimonial_star" />
                  </div>
                  <p className="single-payment__testimonial_content">
                    {t('evieOnboarding.planScreen.testimonials.postpartum.caro.content')}
                  </p>
                  <p className="single-payment__testimonial_author">
                    {t('evieOnboarding.planScreen.testimonials.postpartum.caro.author')}
                  </p>
                </div>
                <img
                  className="single-payment__bgimg testimonialbg"
                  src={linearGradientBg}
                  alt="linear gradient background"
                />
                <img className="single-payment__bgimg single-payment__testimonials_img" src={caro} alt="Woman" />
              </section>
            </SwiperSlide>
            <SwiperSlide>
              <section className="single-payment__testimonials">
                <div className="single-payment__testimonial">
                  <div>
                    <FaStar className="single-payment__testimonial_star" />
                    <FaStar className="single-payment__testimonial_star" />
                    <FaStar className="single-payment__testimonial_star" />
                    <FaStar className="single-payment__testimonial_star" />
                    <FaStar className="single-payment__testimonial_star" />
                  </div>
                  <p className="single-payment__testimonial_content">
                    {t('evieOnboarding.planScreen.testimonials.postpartum.tati.content')}
                  </p>
                  <p className="single-payment__testimonial_author">
                    {t('evieOnboarding.planScreen.testimonials.postpartum.tati.author')}
                  </p>
                </div>
                <img
                  className="single-payment__bgimg testimonialbg"
                  src={linearGradientBg}
                  alt="linear gradient background"
                />
                <img
                  className="single-payment__bgimg single-payment__testimonials_img"
                  src={tati}
                  alt="Woman and baby"
                />
              </section>
            </SwiperSlide>
          </Swiper>
          <section className="single-payment__footer">
            <div className="single-payment__footer_topbg" />
            <div className="single-payment__footer_topbg second" />
            <div className="single-payment__footer_icon">
              <img className="multi-heart-icon" src={heart} alt="heart" />
            </div>
            <h2 className="single-payment__footer_title plan-screen">{t('evieOnboarding.planScreen.title')}</h2>
            <Offerings
              offerings={offerings}
              selectedOffer={selectedOffer}
              setSelectedOffer={setSelectedOffer}
              showSinglePayment
              isDiscount={isDiscount}
              identifier={identifier}
              isFetchingOfferings={isFetchingOfferings}
              showSkipLink={showSkipLink}
            />
          </section>
        </SinglePayment>
      )}
      <ExitOfferModal
        modalIsOpen={isExitModalOpen}
        onAcceptFreeTier={handleAcceptFreeTier}
        onDismiss={handleDismissModal}
      />
    </>
  );
};

PostpartumPlan.defaultProps = {
  selectedOffer: null,
  isDiscount: false,
  identifier: null,
  isFetchingOfferings: false,
};

PostpartumPlan.propTypes = {
  offerings: PropTypes.arrayOf(PropTypes.shape({ identifier: PropTypes.string.isRequired })).isRequired,
  selectedOffer: PropTypes.shape({ identifier: PropTypes.string.isRequired }),
  setSelectedOffer: PropTypes.func.isRequired,
  isDiscount: PropTypes.bool,
  identifier: PropTypes.string,
  isFetchingOfferings: PropTypes.bool,
};

export default PostpartumPlan;
